import React, { useEffect, useState } from "react";
import { Tag, Spin } from "antd";
import dayjs from "dayjs";
import { getInstitutionApi } from "../../../apiservice/setting";
import { numberFormat, convertNumberToWords } from "../../../lib/functions";
import "./supplierPaymentVoucher.css";

const fmt = (d) => (d ? dayjs(d).format("DD/MM/YYYY") : "-");

const statusColor = (val) =>
  val === "approved" ? "green" : val === "rejected" ? "red" : "gold";

const SupplierPaymentVoucherBody = ({ data, printMode = false }) => {
  const [institution, setInstitution] = useState(null);

  useEffect(() => {
    getInstitutionApi()
      .then((res) => setInstitution(res.data))
      .catch(() => setInstitution(null));
  }, []);

  if (!data) {
    return (
      <div className="pv-loading">
        <Spin />
      </div>
    );
  }

  const details = data.details || [];
  const totalPaid = Number(data.pay_total || 0);
  const totalDiscount = Number(data.discount_total || 0);
  const netPaid = totalPaid - totalDiscount;
  const supplierName = data.acc_name || details[0]?.to_acc_name || "-";
  const currency = institution?.currency || "";

  return (
    <div className="payment-voucher">
      <div className="pv-letterhead">
        <div className="pv-company-name">{institution?.name || "-"}</div>
        {(institution?.phone_no || institution?.street_address) && (
          <div className="pv-company-contact">
            {institution?.phone_no && <>TEL : {institution.phone_no}</>}
            {institution?.phone_no && institution?.street_address && ". "}
            {institution?.street_address}
          </div>
        )}
      </div>

      <div className="pv-box">
        <div className="pv-no-date">
          <div>
            <strong>No:</strong> {data.pay_code || "-"}
          </div>
          <div>
            <strong>Date:</strong> {fmt(data.created_date)}
          </div>
        </div>

        <div className="pv-to">
          <div>To</div>
          <div>Mr./Messrs.: {supplierName}</div>
        </div>

        <div className="pv-body-text">
          <p>Sir,</p>
          <p>
            Please find herewith our payment of {currency}{" "}
            <strong>{numberFormat(netPaid)}</strong> (
            {convertNumberToWords(netPaid, institution?.currency)} ) towards
            settlement of the following Bill(s).
          </p>
          <p>Kindly acknowledge the same and send your official receipt.</p>
        </div>

        <table className="pv-details-table">
          <thead>
            <tr>
              <th>Bill No</th>
              <th>From Account</th>
              <th style={{ textAlign: "right" }}>Amount</th>
              <th style={{ textAlign: "center" }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {details.map((d, i) => (
              <tr key={d.pay_d_id || i}>
                <td>{d.voucher_no || "-"}</td>
                <td>{d.from_acc_name || "-"}</td>
                <td style={{ textAlign: "right" }}>
                  {numberFormat(d.pay_amount)}
                </td>
                <td style={{ textAlign: "center" }}>
                  {d.payment_status ? (
                    <Tag color={statusColor(d.payment_status)}>
                      {d.payment_status.charAt(0).toUpperCase() +
                        d.payment_status.slice(1)}
                    </Tag>
                  ) : (
                    "-"
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="pv-totals">
          <div className="row">
            <span>Total Bill Amount :</span>
            <span>{numberFormat(totalPaid)}</span>
          </div>
          {totalDiscount > 0 && (
            <div className="row">
              <span>Discount :</span>
              <span>{numberFormat(totalDiscount)}</span>
            </div>
          )}
          <div className="row net">
            <span>Net Paid :</span>
            <span>{numberFormat(netPaid)}</span>
          </div>
        </div>
      </div>

      <div className="pv-footer">
        {data.narration && (
          <div className="pv-narration">
            <strong>Narration</strong> {data.narration}
          </div>
        )}

        <div className="pv-signature-row">
          <span className="pv-sign-item">
            Prepared By<span className="pv-dots" />
          </span>
          <span className="pv-sign-item">
            Passed By<span className="pv-dots" />
          </span>
          <span className="pv-sign-item">
            Approved By<span className="pv-dots" />
          </span>
        </div>
        <div className="pv-signature-row pv-signature-row-end">
          <span className="pv-sign-item">
            Received By<span className="pv-dots" />
          </span>
        </div>
      </div>
    </div>
  );
};

export default SupplierPaymentVoucherBody;
